import { useQuery } from "react-query";
import { cacheKeys } from "config";
import { mainSurveyClient } from "../client/mainSurveyClient";
import { surveysClient } from "modules/Surveys/client/surveysClient";

export const useMainSurveyData = (parentSurveyId: string | number, blockId?: string | number) => {
  const { data: { data: surveyBlockData } = {}, isLoading } = useQuery(
    [cacheKeys.mainSurvey.getSurveyBlock, parentSurveyId, blockId],
    async () => {
      if (!blockId) {
        return surveysClient.getSurvey(parentSurveyId);
      }

      return mainSurveyClient.getSurveyBlock(parentSurveyId, blockId);
    }
  );

  return {
    surveyBlock: surveyBlockData,
    isLoading,
  };
};
